<template>
  <div id="index">
    <myhead isHome="true"></myhead>
    <div class="content">
      <!-- <img
        class="con-middle"
        src="../assets/imgs/new-middle.jpg"
        alt="Fountain-Scientific"
      /> -->

      <div class="con-middle"></div>

      <div class="con-right">
        <ul class="ul-btn">
          <li class="con-btn1" @click="toPage('apply')">
            <img src="../assets/imgs/coo.png" class="left-icon" />
            <div>Corperation Regisration</div>
            <img src="../assets/imgs/right.png" class="right-icon" />
          </li>
          <li class="con-btn1" @click="toPage('skill')">
            <img src="../assets/imgs/goods.png" class="left-icon" />
            <div>FAQ's</div>
            <img src="../assets/imgs/right.png" class="right-icon" />
          </li>
          <li class="con-btn2" @click="toPage('apply')">
            <img src="../assets/imgs/client.png" class="left-icon" />
            <div>Quotation</div>
            <div class="free">Free</div>
          </li>
          <li class="con-btn2" @click="toPage('consult')">
            <img src="../assets/imgs/buy.png" class="left-icon" />
            <div href="#">Download</div>
            <div class="free">Free</div>
          </li>
        </ul>
        <ul class="ul-notice">
          <div class="h-notice">
            <div>
              <img src="../assets/imgs/notice.png" class="icon-notice" />
              <span>News & Events</span>
            </div>
            <router-link to="/notices" class="notice-more">More ></router-link>
          </div>
          <li v-for="(item, index) in notices" :key="index" class="notice-item">
            <a :href="item.url" target="_blank">
              <img src="../assets/imgs/tri2.png" class="notice-icon" />
              {{ item.name }}
            </a>
            <div class="time">
              {{ item.created_at | time }}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="newRecommend w1200">
      <p>New Products</p>
      <div class="box">
        <ul class="tab">
          <li
            v-for="(item, index) in newItems"
            :key="index"
            :class="index === curIndex ? 'activeTab' : ''"
            @click="changeCurIndex(index)"
          >
            {{ item.name }}
          </li>
        </ul>
        <ul class="items">
          <li
            v-for="(item, index) in itemChildren"
            :key="index"
            class="itemBox"
            @click="detail(item.id)"
          >
            <img :src="item.img" class="itemImg disb" />
            <p class="name">
              {{ item.main }}
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="sectionTab w1200">
      <div class="sec-ul">
        <!-- <li
          v-for="(item, index) in sectionTab"
          :key="index"
          :class="index === secIndex ? 'sec-active' : ''"
        >
          {{ item }}
        </li> -->
        <div class="sec-title">
          Contact Us
        </div>
      </div>

      <div class="sec-con">
        <!--一锅端-->
        <div v-show="secIndex == index" v-for="(item, index) in sectionTab">
          <div class="newsApp food">
            <div
              class="food-box"
              v-for="(item, index) in imfor[item]"
              :key="index"
            >
              <div><img :src="item.image" class="food-img" /></div>
              <div class="food-t">
                <p class="food-title">{{ item.title }}</p>
                <p class="food-text">
                  {{
                    item.subtitle
                      .replace(/<[\/\!]*[^<>]*>/gi, "")
                      .replace(/&(?!nsbp;)[a-zA-Z]*;/g, "")
                  }}
                </p>
                <router-link
                  :to="{ path: '/article/' + item.id }"
                  class="sec-a tech-a"
                  v-if="!item.url"
                  >Learn more</router-link
                >
                <!--视频-->
                <a :href="item.url" v-if="item.url">Learn more</a>
              </div>
            </div>
          </div>
        </div>

        <!--&lt;!&ndash; 尖端科技 &ndash;&gt;-->
        <!--<div v-show="secIndex == 0">-->
        <!--<div class="tech">-->
        <!--<div class="tech-box" v-for="(item,index) in topTechs" :key="index">-->
        <!--<div><img :src="item.image" class="tech-img"></div>-->
        <!--<div class="tech-text">-->
        <!--<p class="tech-intro">{{item.intro}}</p>-->
        <!--<a :href="item.url" class="sec-a tech-a">了解更多</a>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--&lt;!&ndash; 网络研讨会 &ndash;&gt;-->
        <!--<div v-show="secIndex == 1">-->
        <!--<div class="web">-->
        <!--<div class="web-left">-->
        <!--<img src="../assets/imgs/web.png" class="web-logo">-->
        <!--<p class="web-title">近期网络讲座报名</p>-->
        <!--<p>干细胞培养及基因编辑前沿应用联合研讨会</p>-->
        <!--<p class="web-text">试剂对色谱、质谱检测结果的影响</p>-->
        <!--<a href="#" class="sec-a">观看讲座</a>-->
        <!--</div>-->
        <!--<div class="web-right">-->
        <!--<div class="web-box"  v-for="(item,index) in webs" :key="index">-->
        <!--<div class="web-t">-->
        <!--<p class="webRight-title tech-title">{{item.title}}</p>-->
        <!--<p class="web-text">{{item.intro}}</p>-->
        <!--<a :href="item.url" class="sec-a">观看讲座</a>-->
        <!--</div>-->
        <!--<img :src="item.image" class="web-img">-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--&lt;!&ndash; 食药资讯 &ndash;&gt;-->
        <!--<div v-show="secIndex == 2">-->
        <!--<div class="food">-->
        <!--<div class="food-box" v-for="(item,index) in foods" :key="index">-->
        <!--<div><img :src="item.image" class="food-img"></div>-->
        <!--<div class="food-t">-->
        <!--<p class="food-title">{{item.title}}</p>-->
        <!--<p class="food-text">{{item.subtitle}}</p>-->
        <!--<router-link :to="'/foods/foods/'+index" class="sec-a tech-a">了解更多</router-link>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--&lt;!&ndash; 最新应用 排版跟食药一样&ndash;&gt;-->
        <!--<div v-show="secIndex == 3">-->
        <!--<div class="newsApp food">-->
        <!--<div class="food-box" v-for="(item,index) in newApps" :key="index">-->
        <!--<div><img :src="item.image" class="food-img"></div>-->
        <!--<div class="food-t">-->
        <!--<p class="food-title">{{item.title}}</p>-->
        <!--<p class="food-text">{{item.content}}</p>-->
        <!--<router-link :to="'/foods/newsApp/'+index" class="sec-a tech-a">了解更多</router-link>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!-- 联系我们 -->
        <div v-show="secIndex == 4" class="sec-consult">
          <div class="consult">
            <p v-for="(item, index) in contact">
              {{ item.title }}：{{ item.value }}
            </p>
          </div>
          <!-- test -->
          <!-- <div class="consult">
            <p>Please contact: Fountain Scientific</p>
            <p>Phone: +86 18933991306</p>
            <p>Wechat: Choi-HongNeng</p>
            <p>Tel: +86 020 26220985</p>
            <p>Fax: +86 020 26220985</p>
            <p>E-mail: info@fountain-scientific.com, mahone.cai@fountain-scientific.com</p>
            <p>Address: Room C-103, No. 8, Hefeng 3rd Street, Huangpu District, Guangzhou City</p>
            <p>Business Hours: 9:00 a.m. to 6:00 p.m. (except Saturdays, Sundays, holidays and our company's closed days)</p>
            <p>If it is not our working day, please send us massage and we will come back to you as soon sa possible. We are all happy to help. </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myhead from "./common/header.vue";
import axios from "axios";
const url = require("../url").url;
export default {
  name: "Index",
  components: {
    myhead,
  },
  watch: {
    // 如果curIndex有变化，会再次执行该方法
    curIndex() {
      this.newproduct();
    },
  },
  created() {
    this.newproduct();
    //获取公告
    axios
      .get(url.notices, { params: { is_index: 1 } })
      .then((response) => {
        this.notices = response.data.data;
        console.log(this.notices);
        // test
        // const testArray = [
        //   "The Latest Features",
        //   "Job Offers",
        //   "User Guide",
        //   "Offer(Manager Assistant)",
        // ];
        // this.notices.forEach((item, index) => {
        //   item.name = testArray[index];
        // });
      })
      .catch((error) => {
        console.log(error);
        alert("get notice failed");
      });
    //获取尖端科技
    axios
      .get(url.topTech, { params: { is_index: 1 } })
      .then((response) => {
        this.topTechs = response.data.data;
      })
      .catch((error) => {
        console.log(error);
        alert("get topTechs failed");
      });
    //获取网络研讨会
    axios
      .get(url.web, { params: { is_index: 1 } })
      .then((response) => {
        this.webs = response.data.data;
      })
      .catch((error) => {
        console.log(error);
        alert("get webs failed");
      });
    //获取食药资讯
    axios
      .get(url.food, { params: { is_index: 1 } })
      .then((response) => {
        this.foods = response.data.data;
      })
      .catch((error) => {
        console.log(error);
        alert("get foods failed");
      });
    //最新应用
    axios
      .get(url.newApp, { params: { is_index: 1 } })
      .then((response) => {
        this.newApps = response.data.data;
      })
      .catch((error) => {
        console.log(error);
        alert("get new failed");
      });
    //获取数据
    axios
      .get(url.imfor)
      .then((response) => {
        let imfor = response.data.data;
        this.imfor = imfor;
        let sectionTab = [];
        for (let key in imfor) {
          sectionTab.push('');
        }
        sectionTab.push("Contact Us");
        this.sectionTab = sectionTab;
        // test

      })
      .catch((error) => {
        console.log(error);
        alert("get new data failed");
        //若
      });
    axios
      .get(url.contact)
      .then((response) => {
        let contact = response.data;
        this.contact = contact;
        console.log(contact);
        console.log(1)
      })
      .catch((error) => {
        console.log(error);
        alert("get new app data failed");
        //若
      });
  },
  data() {
    return {
      // sectionTab
      sectionTab: [],
      imfor: {},
      // 控制新品推荐显示的item。初始化为0
      curIndex: 0,
      // 控制tab板块显示的板块，初始化为4->联系我们
      secIndex: 4,
      newItems: "",
      itemChildren: "",
      //公告，默认显示4条，点击更多获取更多
      notices: [],
      //尖端科技视频，默认显示4条
      topTechs: [],
      //网络研讨会
      webs: [],
      //食药咨询
      foods: [],
      //最新应用
      newApps: [],
      //联系方式
      contact: [
        { title: "", value: "" },
        { title: "", value: "" },
        { title: "", value: "" },
        { title: "", value: "" },
        { title: "", value: "" },
        { title: "", value: "" },
      ],
    };
  },
  filters: {
    time(value) {
      return value.split(" ")[0];
    },
  },
  methods: {
    newproduct() {
      //获取新品推荐
      let self = this;
      this.$ajax({
        url: "https://fountain-scientific.com/v2/new",
        type: "GET",
        data: "{}",
        success: function (data) {
          self.newItems = data.data;
          console.log("new",data.data);
          self.itemChildren = data.data[self.curIndex].children;
          // test
          // const testArray = [
          //   "Cell/Tissue Culture",
          //   "Microplates",
          //   "Immunology",
          //   "Microbiology/Bacteriology",
          //   "Tubes/Multipurpose Beakers",
          //   "Liquid Handling",
          //   "Molecular Biology",
          //   "Separation",
          // ];
          // self.newItems.forEach((item, index) => {
          //   item.name = testArray[index];
          // })

          // const testChildren = [
          //   {id : 1, img : '/static/test-p-50mm.jpg', main : '50mm Petri Dishes'},
          //   {id : 2, img : '/static/test-p-60mm.jpg', main : '60mm Petri Dishes'},
          //   {id : 3, img : '/static/test-p-90mm.jpg', main : '90mm Petri Dishes'},
          //   {id : 4, img : '/static/test-p-92mm.jpg', main : '92mm Petri Dishes'},
          //   {id : 5, img : '/static/test-p-55mm.jpg', main : '55mm Contact Dishes'},
            
          // ]
          // self.itemChildren = testChildren;
        },
        error: function (res) {
          console.log(res);
        },
      });
    },
    toPage(value) {
      let session = sessionStorage.getItem("user");
      if (!session) {
        alert("Please login");
      } else {
        this.$router.push(value);
      }
    },
    changeCurIndex(index) {
      this.curIndex = index;
      let i = index + 1;
      axios
        .get(url.newGoods, { params: { type: i } })
        .then((response) => {
          let data1 = response.data.data;
          this.newItems[index].items = data1;
        })
        .catch((error) => {
          console.log(error);
          alert("network error");
        });
    },
    changeSecIndex(index) {
      this.secIndex = index;
    },
    detail(id) {
      this.$router.push({
        path: "detail",
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import url("../assets/css/style.less");

.disb {
  display: block;
}
.w1200 {
  width: 80vw;
  margin: 0 auto;
  min-width: 1200px;
}
/* 公告和主图 */
.content {
  display: flex;
  height: 340px;
  margin: 5px auto;
  width: 80vw;
  min-width: 1200px;
}
.con-middle {
  margin-left: 237px;
  border: 1px #d5d5d5 solid;
  width: 700px;
  background: url("../assets/imgs/new-middle.jpg");
  background-size: cover;
  background-position-y: -41px;
}
.con-right {
  min-width: 240px;
  margin-left: 10px;
  padding: 5px 10px;
  border: 1px #d5d5d5 solid;
  flex-grow: 2;
}
/* 新品推荐 */
.newRecommend {
  margin: 20px auto;
  font-size: 12px;
}
.newRecommend > p {
  text-align: left;
  /* color: #e40011; */
  color: @indexTheme;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
}
.newRecommend .box {
  border: 1px solid #ddd;
}
.tab {
  text-align: left;
  /* border-top: 2px solid #e70012; */
  border-top: 2px solid @indexTheme;
  overflow: hidden;
  display: flex;
}
.tab > li {
  text-align: center;
  line-height: 42px;
  height: 42px;
  border: 1px solid #ddd;
  background-color: #f4f4f4;
  flex-grow: 1;
}
.tab li.activeTab {
  border-bottom: none;
  /* color: #e70012; */
  color: @indexTheme;
  background-color: #fff;
}
.items {
  text-align: left;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  overflow-x: auto;
}
.items::-webkit-scrollbar {
  height: 8px;
  background-color: #ddd;
}
.items::-webkit-scrollbar-thumb {
  background-color: #999;
}
.itemBox {
  // margin: 30px 10px;
  // width: 194px;
  height: 200px;
  text-align: center;
  font-size: 12px;
}
.itemImg {
  height: 140px;
  margin: 10px 30px;
}
.name {
  margin: 15px 30px;
}
.name {
  font-weight: 600;
}
.name:hover {
  /* color: red; */
  color: @indexTheme;
}
/* 公告按钮部分 */
.left-icon,
.right-icon {
  width: 20px;
  height: 20px;
}
.con-btn1 {
  cursor: pointer;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  height: 56px;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  /* background-color: #DB0111; */
  background-color: @indexTheme;
  margin-bottom: 5px;
  padding: 0 50px;
}

.con-btn2 {
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 50px;
  font-size: 16px;
  font-weight: 600;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  display: flex;
  border: 1px #d5d5d5 solid;
  margin-bottom: 5px;
  background: -webkit-linear-gradient(#fff 10%, #e4e4e4);
  background: -o-linear-gradient(#fff 10%, #e4e4e4);
  background: -moz-linear-gradient(#fff 10%, #e4e4e4);
  background: linear-gradient(#fff 10%, #e4e4e4);
  /* change color */
  overflow: hidden;
}

.con-btn2 img {
  /* change color */
  position: relative;
  left: -1000px;
  filter: drop-shadow(1000px 0 @indexTheme);
}
.free {
  color: #fff;
  /* background-color: #DB0111; */
  background-color: @indexTheme;
  font-size: 12px;
  padding: 3px 5px;
}
.icon-notice {
  width: 15px;
  height: 15px;
  filter: drop-shadow(1000px 0 @indexTheme);
  position: relative;
  left: -1000px;
}
.h-notice {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 2px;
  border-bottom: 1px dashed #ddd;
}
.notice-more {
  font-size: 12px;
}
.notice-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-top: 2px;
}

.notice-item a:hover {
  color: @indexTheme;
}
.notice-icon {
  width: 5px;
  height: 5px;
}
.time {
  font-size: 12px;
  color: #808080;
}
/* tab板块 */
.sec-a {
  color: rgb(0, 119, 229);
  font-size: 14px;
  text-align: left;
}
/* 联系我们 */
.sectionTab {
  margin-bottom: 60px;
}
.sec-ul {
  margin-top: 30px;
  /* border: 1px solid #EE2D36; */
  border: 1px solid @indexTheme;
  border-bottom: 0;
  display: flex;
  background-color: @indexTheme;
  height: 40px;
  line-height: 40px;
  justify-content: center;
}
.sec-ul > li {
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  flex-grow: 1;
}
.sec-ul > .sec-active {
  color: black;
  background-color: #fff;
}
.sec-con {
  height: 350px;
  /* border: 1px solid #EE2D36; */
  border: 1px solid @indexTheme;
  border-top: 0;
  overflow-y: auto;
}
.sec-con::-webkit-scrollbar {
  width: 8px;
  background-color: #ddd;
}
.sec-con::-webkit-scrollbar-thumb {
  /* background-color: red; */
  background-color: @indexTheme;
}
.sec-consult {
  /*padding: 45px 80px;*/
  padding-top: 0px;
  height: 80%;
  box-sizing: border-box;
}
.consult {
  position: relative;
  font-size: 15px;
  text-align: left;
  box-sizing: border-box;
  background: url("../assets/imgs/consult.png") no-repeat;
  background-position: top right;
  background-size: auto 100%;
  height: 350px;
  background-color: #eeeeee;
  padding: 50px 40px;
  overflow: scroll;
}
.consult ::-webkit-scrollbar {
  display: block;
  width: 8px;
  background-color: #ddd;
}
.consult::-webkit-scrollbar-thumb {
  /* background-color: red; */
  background-color: @indexTheme;
}
.consult > p {
  margin-bottom: 20px;
}
.f-weight {
  font-size: 18px;
  font-weight: 600;
}
.f-red {
  font-weight: 600;
  /* color: red; */
  color: @indexTheme;
}
.slogan {
  font-size: 18px;
  margin-top: 30px;
}
/* 尖端科技 */
.tech {
  display: flex;
  flex-wrap: wrap;
  padding: 50px;
}
.tech-box {
  text-align: left;
  width: 43%;
  display: flex;
  margin: 0 50px 50px 0;
}
.tech-a {
  position: absolute;
  bottom: 0;
  left: 0;
}
.tech-title,
.web-title,
.food-title {
  font-weight: 600;
  font-size: 16px;
  text-align: left;
}
.tech-text {
  position: relative;
  font-size: 15px;
  margin-left: 40px;
  max-width: 290px;
}
.tech-img {
  width: 180px;
  height: 130px;
}
/* 网络研讨会 */
.web {
  text-align: left;
  display: flex;
  padding: 50px;
}
.web-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.web-t {
  margin-right: 30px;
}
.web-title {
  margin: 15px 0;
}
.web-text {
  margin: 15px 0;
  max-width: 530px;
}
.web-right {
  margin-left: 30px;
}
.web-img,
.food-img {
  width: 140px;
  height: 110px;
}
/* 食药咨询  */
.food {
  padding: 0px 50px;
  text-align: left;
}
.food-box {
  display: flex;
  text-align: left;
  margin-top: 30px;
  margin-bottom: 30px;
}
.food-t {
  margin-left: 30px;
  position: relative;
}
.food-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin: 5px 0;
  max-width: 943px;
}

.sec-title {
  font-weight: bold;
  color: #fff;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue